import { render } from "./ModuleSidebar.vue?vue&type=template&id=0e3b0750&scoped=true"
import script from "./ModuleSidebar.vue?vue&type=script&lang=js"
export * from "./ModuleSidebar.vue?vue&type=script&lang=js"

import "./ModuleSidebar.vue?vue&type=style&index=0&id=0e3b0750&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e3b0750"],['__file',"src/components/ModuleSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e3b0750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e3b0750', __exports__)) {
    api.reload('0e3b0750', __exports__)
  }
  
  module.hot.accept("./ModuleSidebar.vue?vue&type=template&id=0e3b0750&scoped=true", () => {
    api.rerender('0e3b0750', render)
  })

}


export default __exports__